export default "__VITE_ASSET__gWnpMGVD__"